
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    clickable: {
      type: Boolean,
    },
  },
});
